import ProductSelection from "../product/ProductSelection";
import { SelectableType } from "../support/Selectable";

export default function RadioButtonTypeAddonGroup() {
  return (
    <>
      <ProductSelection
        label={"Ingredient Name"}
        selected={false}
        selectionType={SelectableType.RadioButton}
        onChange={() => {}}
        priceLabel={"100 kr"}
      />
      <ProductSelection
        label={"Ingredient Name"}
        selected
        selectionType={SelectableType.RadioButton}
        onChange={() => {}}
        priceLabel={"100 kr"}
      />
    </>
  );
}
